export default __webpack_public_path__ + "3f3bdef0019a5c4d16a544faa79d03be.png";